export default {"src":"/uk/_next/static/media/icon-driving-license.1d97dc73.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};